import React from "react";
import PropTypes from "prop-types";

function Layout1(props) {
  const { children } = props;
  return <div className="hidden md:block">{children}</div>;
}

Layout1.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};

Layout1.defaultProps = {
  children: <div />,
};

export default Layout1;
